import { HttpStatus } from '@nestjs/common';

export enum AiAssistanceReactionType {
  LIKE = 'like',
  DISLIKE = 'dislike',
  NONE = 'null',
}

export interface AiAssistanceChatMessage {
  role: AssistanceUserType;
  content: string;
}

export enum AssistanceUserType {
  USER = 'user',
  ASSISTANT = 'assistant',
}

export interface AiAssistanceChatHistory {
  id: number;
  displayQuestion: string;
  createdAt: string;
  updatedAt: string;
}

export interface AiAssistanceChat {
  id: number;
  question: string;
  createdAt: string;
  updatedAt: string;
  responses: AiAssistanceChatMessage[];
}

export interface AiChatResponse {
  id: number;
  response: string;
  createdAt: string;
  updatedAt: string;
  reaction: AiAssistanceReactionType;
}

export interface SendChatResponse {
  response: string;
  question: {
    id: number;
    question: string;
    createdAt: string;
    updatedAt: string;
    conversation: {
      id: number;
      displayQuestion: string;
      createdAt: string;
      updatedAt: string;
    };
  };
  createdAt: string;
  updatedAt: string;
  reaction: string | null;
  id: number;
}

export interface AiSuggestedQuestions {
  createdAt: string;
  id: number;
  isVisible: boolean;
  question: string;
  updatedAt: string;
}

export interface AiServerResponse {
  status: HttpStatus;
  data: {
    message: string;
    cache?: {
      id?: number;
      intent?: string[];
      sqlQuery?: string;
      regeneratedQuery?: string;
      selectedFewShots?: number[];
      parentId?: number;
      selectedTables?: string[];
      usedTables?: string[];
    };
  };
}

interface Question {
  question: string | null;
  sqlQuery: string;
  regeneratedQuery?: string;
  accessCount: number;
  intent?: string[];
  selectedTables?: string[];
  selectedFewShots?: number[];
  usedTables?: string[];
  cacheId: number;
}
export interface TransformedQuestion extends Question {
  contextual_questions: Record<string, Question>;
}
